import cn from 'classnames';
import { Select } from '@components/antd';
import { useTranslation } from 'react-i18next';
import { useFlags } from 'launchdarkly-react-client-sdk';
import Button from '@components/shared/V2Button';
import s from './Portfolio.module.less';

type Props = {
  marketSlugs: string[];
  selectedRegionSlug: string | null;
  setSelectedRegionSlug: (slug: string) => void;
};

const RegionButtonGroup = ({ marketSlugs, selectedRegionSlug, setSelectedRegionSlug }: Props) => {
  const { t } = useTranslation('');
  const flags = useFlags();
  return marketSlugs.length > 1 ? (
    <>
      {/* button for desktop mobile */}
      <div className={s.buttons}>
        {marketSlugs.map(marketSlug => (
          <Button
            className={cn(marketSlug === selectedRegionSlug && s.selected)}
            type="tertiary"
            key={marketSlug}
            onClick={() => {
              setSelectedRegionSlug(marketSlug);
            }}
          >
            {flags['public-london-market']
              ? t(`common:markets.${marketSlug}`)
              : t(`common:deprecatedMarkets.${marketSlug}`)}
          </Button>
        ))}
      </div>
      {/* button for mobile & tablet */}
      <div className={s.buttonsDevice}>
        <Select
          className={s.buttonsDeviceSelect}
          value={selectedRegionSlug}
          onChange={(slug: string) => setSelectedRegionSlug(slug)}
        >
          {marketSlugs.map(marketSlug => (
            <Select.Option value={marketSlug} key={marketSlug}>
              {flags['public-london-market']
                ? t(`common:markets.${marketSlug}`)
                : t(`common:deprecatedMarkets.${marketSlug}`)}
            </Select.Option>
          ))}
        </Select>
      </div>
    </>
  ) : null;
};

export default RegionButtonGroup;
